import isFolderSupported from 'mini-mail-folder-store/lib/utils/isFolderSupported';
import { getStore } from 'owa-mail-store/lib/store/Store';

export default function getValidFolders(folderIds: string[]): string[] {
    const { folderTable } = getStore().folders;
    return folderTable
        ? folderIds.filter(folderId => isFolderSupported(folderTable.get(folderId)))
        : [];
}
